import { render, staticRenderFns } from "./Dwxxbgsq.vue?vue&type=template&id=7ce05b2b"
import script from "./Dwxxbgsq.vue?vue&type=script&lang=js"
export * from "./Dwxxbgsq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports